import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import "./ReturnsAndStatistics.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import moment from "moment/moment";
import { TileLayout } from "@progress/kendo-react-layout";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import {
  Chart,
  ChartLegend,
  ChartTitle,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartValueAxis,
  ChartValueAxisItem,
  ChartSeries,
  ChartSeriesItem,
} from "@progress/kendo-react-charts";
import close from "../../asset/Images/close_svg.svg";
import $ from "jquery";
import { sbaAxios } from "../../utils/sbaAxios";
import { updateCustomSettings } from "../../../config/apiConfig";

const SummaryTab = (props) => {
  const {summarydata, showIcon, cancelShow, CalendarExcel, IsSave, setIsSave, setcancelshow, setupdateshow, setShowIcon, SummaryWidgetCollections, WidgetPosition,MktIndexName,RadioValue } = props;
  const Gstate =
  useSelector((state) => {
    return state;
  }) || {};
  const [Loading, setLoading] = useState(false);
  const [rorGridbuttonActive, setRorGridbuttonActive] = useState(true);
  const [rorChartbuttonActive, setRorChartbuttonActive] = useState(false);
  const [stdDevGridbuttonActive, setStdDevGridbuttonActive] = useState(true);
  const [stdDevChartbuttonActive, setStdDevChartbuttonActive] = useState(false);
  const [WidgetCollections, setWidgetCollections] = useState(SummaryWidgetCollections);
  const [data, setData] = useState(WidgetPosition);
  const [tiles, setTiles] = useState();
  const VsBMCalyrsData = Gstate.ReturnsGridData.VsBMCalyrsData;
  const BMDDHistoryData = Gstate.ReturnsGridData.BMDDHistoryData;
  const chartLoading =Gstate.ReturnsGridData.chartLoading;
  const vsbmCalendarYrs = VsBMCalyrsData || [];
  const [isChartLoading,setIsChartLoading]=useState(true);
  const BMStatSummaryRorData = Gstate.ReturnsGridData?.BMStatSummaryRorData;
  const dt=summarydata?.SummaryLines||[];
  const Rordata=dt?.filter(item => item.StatDesc==="RoR");
  const stRordata = Rordata.map((stat) => ({
    ...stat,
    Entities: stat.Entities.map((item) => ({
      ...item,
      PeriodDesc: RadioValue === 5
        ? item.PeriodDesc === "Since Inception"
          ? "Selected Date"
          : item.PeriodDesc
        : item.PeriodDesc,
    })),
  }));
  
  const [firstRorSummaryLine] =  stRordata;

    const uniqueNames = [
      ...new Set(
        Array.isArray(vsbmCalendarYrs)
          ? vsbmCalendarYrs.reduce((accumulator, set) => {
            set.CalYrVals.forEach(({ EntityName }) => {
              accumulator.push(EntityName);
            });
            return accumulator;
          }, [])
          : []
      ),
    ];
  
  useEffect(() => {
    if (IsSave) {
      SaveWidgetSettings();
    }
    setIsChartLoading(true);
    loadSummaryWidgets();
  }, [Gstate,props]);

  // useEffect(()=>{
  //   setIsChartLoading(isChartLoading);
  // },[isChartLoading]);

  //BM Calendar Grid

 

  
  const columnDefs = [
    { headerName: "Year", field: "Year", width: 100 },
    ...uniqueNames.map((EntityName) => ({
      headerName: EntityName,
      field: EntityName,
      cellStyle: (params) => ({
        textAlign: "right",
        color: params.value < 0 ? "red" : "",
      }),
      headerTooltip: `${EntityName}`,
      valueFormatter: (params) => {
        const value = params.value ? params.value * 100 : null;
        if (value !== null) {
          const formattedValue = Number(value).toFixed(1);
          return `${formattedValue}%`;
        }
      },
    })),
  ];

  const rowData = Array.isArray(vsbmCalendarYrs)
    ? vsbmCalendarYrs.reduce((accumulator, set) => {
      const Year = set.Year;
      const row = { Year };
      set.CalYrVals.forEach(({ EntityName, EntityValue }) => {
        row[EntityName] = EntityValue;
      });
      accumulator.push(row);
      return accumulator;
    }, [])
    : [];

  //Stat Summary Widgets
  // Ror


  const rorDatacolumnDefs = [
    {
      headerName: "Periods",
      field: "PeriodDesc",
      pinned: "left",
    },
    ...(firstRorSummaryLine?.Entities?.[0]?.Stats || []).map((stat) => ({
      headerName: stat?.EntityName===null?MktIndexName:stat?.EntityName,
      field: `StatValue_${stat?.EntityName}`,
      valueFormatter: percentFormatter,
      cellStyle: colorCellStyle,
      headerTooltip: `${stat?.EntityName}`,
    })),
  ];

  const rorRowData = (firstRorSummaryLine?.Entities || []).map((entity) => {
    const row = { PeriodDesc: entity.PeriodDesc };
    (entity.Stats || []).forEach((stat) => {
      row[`StatValue_${stat?.EntityName}`] = stat?.StatValue;
    });
    return row;
  });

  const rorData = firstRorSummaryLine?.Entities?.[0]?.Stats.map((stat) =>
    rorRowData.map((row) =>
      parseFloat(row[`StatValue_${stat.EntityName}`] * 100).toFixed(2)
    )
  );

  // const allRorValues = rorData?.flat();
  // const minRor = Math?.min(...allRorValues);
  // const maxRor = Math?.max(...allRorValues);
  // const roundedMinRor = Math?.floor(minRor / 5) * 5;
  // const roundedMaxRor = Math?.ceil(maxRor / 5) * 5;

  //Ror Chart
  const rorChart = (
    <Chart>
      <ChartCategoryAxis>
        <ChartCategoryAxisItem
          categories={rorRowData.map((row) => row.PeriodDesc)}
          labels={{
            position: "start",
          }}
        />
      </ChartCategoryAxis>
      <ChartSeries>
        {firstRorSummaryLine?.Entities?.[0]?.Stats.map((stat, index) => (
          <ChartSeriesItem
            key={index}
            data={rorData[index]}
            name={stat.EntityName}
            type="column"
            color={
              index === 0 ? "#1B9C85" : index === 1 ? "#FF8686" : "#05BFDB"
            }
            tooltip={{ visible: true, format: "{0}%" }}
            justified={true}
          />
        ))}
      </ChartSeries>
      <ChartLegend position="bottom" />
      <ChartValueAxis>
        <ChartValueAxisItem
          axisCrossingValue={[0, -100000000000000000, 0, 0]}
          labels={{ format: "{0}%", position: "right" }}
          majorGridLines={{ visible: false }}
        // min={roundedMinRor}
        // max={roundedMaxRor}
        // majorUnit={5}
        />
      </ChartValueAxis>
    </Chart>
  );

  // StdDev
  const BMStatSummaryStdDevData =
    Gstate.ReturnsGridData?.BMStatSummaryStdDevData;
    const Stddata=dt?.filter(item => item.StatDesc==="Standard Deviation");
    const Stddatadt = Stddata.map((stat) => ({
      ...stat,
      Entities: stat.Entities.map((item) => ({
        ...item,
        PeriodDesc: RadioValue === 5
          ? item.PeriodDesc === "Since Inception"
            ? "Selected Date"
            : item.PeriodDesc
          : item.PeriodDesc,
      })),
    }));
  const [firstStdDevSummaryLine] = Stddatadt;

  const stdDevDatacolumnDefs = [
    {
      headerName: "Periods",
      field: "PeriodDesc",
      pinned: "left",
    },
    ...(firstStdDevSummaryLine?.Entities?.[0]?.Stats || []).map((stat) => ({
      headerName: stat?.EntityName===null?MktIndexName:stat?.EntityName,
      field: `StatValue_${stat?.EntityName}`,
      valueFormatter: percentFormatter,
      cellStyle: colorCellStyle,
      headerTooltip: `${stat?.EntityName}`,
    })),
  ];

  const stdDevRowData = (firstStdDevSummaryLine?.Entities || []).map(
    (entity) => {
      const row = { PeriodDesc: entity.PeriodDesc };
      (entity.Stats || []).forEach((stat) => {
        row[`StatValue_${stat?.EntityName}`] = stat?.StatValue;
      });
      return row;
    }
  );

  const StdDevData = firstStdDevSummaryLine?.Entities?.[0]?.Stats.map((stat) =>
    stdDevRowData.map((row) =>
      parseFloat(row[`StatValue_${stat.EntityName}`] * 100).toFixed(2)
    )
  );

  // const allStdDevValues = StdDevData?.flat();
  // const minStdDev = Math.min(...allStdDevValues);
  // const maxStdDev = Math.max(...allStdDevValues);
  // const roundedMinStdDev = Math.floor(minStdDev / 5) * 5;
  // const roundedMaxStdDev = Math.ceil(maxStdDev / 5) * 5;

  //StdDev Chart
  const stdDevChart = (
    <Chart>
      <ChartCategoryAxis>
        <ChartCategoryAxisItem
          categories={stdDevRowData.map((row) => row.PeriodDesc)}
          labels={{
            position: "start",
          }}
        />
      </ChartCategoryAxis>
      <ChartSeries>
        {firstStdDevSummaryLine?.Entities?.[0]?.Stats.map((stat, index) => {
          return (
            <ChartSeriesItem
              key={index}
              data={StdDevData[index]}
              name={stat.EntityName}
              type="column"
              color={
                index === 0 ? "#1B9C85" : index === 1 ? "#FF8686" : "#05BFDB"
              }
              tooltip={{ visible: true, format: "{0}%" }}
              justified={true}
            />
          );
        })}
      </ChartSeries>
      <ChartLegend position="bottom" />
      <ChartValueAxis>
        <ChartValueAxisItem
          axisCrossingValue={[0, -100000000000000000, 0, 0]}
          labels={{ format: "{0}%", position: "right" }}
          majorGridLines={{ visible: false }}
        // min={roundedMinStdDev}
        // max={roundedMaxStdDev}
        // majorUnit={5}
        />
      </ChartValueAxis>
    </Chart>
  );

  // Sharpe
  const BMStatSummarySharpeData =
    Gstate.ReturnsGridData?.BMStatSummarySharpeData;
    const Sharperatiodata= dt?.filter(item => item.StatDesc==="Sharpe Ratio");
    const Sharpedt = Sharperatiodata.map((stat) => ({
      ...stat,
      Entities: stat.Entities.map((item) => ({
        ...item,
        PeriodDesc: RadioValue === 5
          ? item.PeriodDesc === "Since Inception"
            ? "Selected Date"
            : item.PeriodDesc
          : item.PeriodDesc,
      })),
    }));
  const [firstSharpeSummaryLine] =Sharpedt;

  const sharpeDatacolumnDefs = [
    {
      headerName: "Periods",
      field: "PeriodDesc",
      pinned: "left",
    },
    ...(firstSharpeSummaryLine?.Entities?.[0]?.Stats || []).map((stat) => ({
      headerName: stat?.EntityName===null?MktIndexName:stat?.EntityName,
      field: `StatValue_${stat?.EntityName}`,
      valueFormatter: numberFormatter,
      cellStyle: colorCellStyle,
      headerTooltip: `${stat?.EntityName}`,
    })),
  ];

  const sharpeRowData = (firstSharpeSummaryLine?.Entities || []).map(
    (entity) => {
      const row = { PeriodDesc: entity.PeriodDesc };
      (entity.Stats || []).forEach((stat) => {
        row[`StatValue_${stat?.EntityName}`] = stat?.StatValue;
      });
      return row;
    }
  );

  // Sortino
  const BMStatSummarySortinoData =
    Gstate.ReturnsGridData?.BMStatSummarySortinoData;

    const Sortinodata=   dt?.filter(item => item.StatDesc==="Sortino Ratio");
    const Sortinodt = Sortinodata.map((stat) => ({
      ...stat,
      Entities: stat.Entities.map((item) => ({
        ...item,
        PeriodDesc: RadioValue === 5
          ? item.PeriodDesc === "Since Inception"
            ? "Selected Date"
            : item.PeriodDesc
          : item.PeriodDesc,
      })),
    }));
  const [firstSortinoSummaryLine] =Sortinodt


  const sortinoDatacolumnDefs = [
    {
      headerName: "Periods",
      field: "PeriodDesc",
      pinned: "left",
    },
    ...(firstSortinoSummaryLine?.Entities?.[0]?.Stats || []).map((stat) => ({
      headerName:stat?.EntityName===null?MktIndexName:stat?.EntityName,
      field: `StatValue_${stat?.EntityName}`,
      valueFormatter: numberFormatter,
      cellStyle: colorCellStyle,
      headerTooltip: `${stat?.EntityName}`,
    })),
  ];

  const sortinoRowData = (firstSortinoSummaryLine?.Entities || []).map(
    (entity) => {
      const row = { PeriodDesc: entity.PeriodDesc };
      (entity.Stats || []).forEach((stat) => {
        row[`StatValue_${stat?.EntityName}`] = stat?.StatValue;
      });
      return row;
    }
  );

  // MaxDrawdown
  const BMStatSummaryMaxDrawdownData =
    Gstate.ReturnsGridData?.BMStatSummaryMaxDrawdownData;

    const MaxDrawdowndata=dt?.filter(item => item.StatDesc==="Max Drawdown");

    const MaxDrawdowndt = MaxDrawdowndata.map((stat) => ({
      ...stat,
      Entities: stat.Entities.map((item) => ({
        ...item,
        PeriodDesc: RadioValue === 5
          ? item.PeriodDesc === "Since Inception"
            ? "Selected Date"
            : item.PeriodDesc
          : item.PeriodDesc,
      })),
    }));
  const [firstMaxDrawdownSummaryLine] =MaxDrawdowndt;

  const maxDrawdownDatacolumnDefs = [
    {
      headerName: "Periods",
      field: "PeriodDesc",
      pinned: "left",
    },
    ...(firstMaxDrawdownSummaryLine?.Entities?.[0]?.Stats || []).map(
      (stat) => ({
        headerName: stat?.EntityName===null?MktIndexName:stat?.EntityName,
        field: `StatValue_${stat?.EntityName}`,
        valueFormatter: percentFormatter,
        cellStyle: colorCellStyle,
        headerTooltip: `${stat?.EntityName}`,
      })
    ),
  ];

  const maxDrawdownRowData = (firstMaxDrawdownSummaryLine?.Entities || []).map(
    (entity) => {
      const row = { PeriodDesc: entity.PeriodDesc };
      (entity.Stats || []).forEach((stat) => {
        row[`StatValue_${stat?.EntityName}`] = stat?.StatValue;
      });
      return row;
    }
  );

  // Correlation
  const BMStatSummaryCorrelationData =
    Gstate.ReturnsGridData?.BMStatSummaryCorrelationData;
    const Correlationdata=dt?.filter(item => item.StatDesc==="Correlation");
    const Correlationdt = Correlationdata.map((stat) => ({
      ...stat,
      Entities: stat.Entities.map((item) => ({
        ...item,
        PeriodDesc: RadioValue === 5
          ? item.PeriodDesc === "Since Inception"
            ? "Selected Date"
            : item.PeriodDesc
          : item.PeriodDesc,
      })),
    }));
  const [firstCorrelationSummaryLine] =Correlationdt;
  
  const correlationDatacolumnDefs = [
    {
      headerName: "Periods",
      field: "PeriodDesc",
      pinned: "left",
    },
    ...(firstCorrelationSummaryLine?.Entities?.[0]?.Stats || []).map(
      (stat) => ({
        headerName: stat?.EntityName===null?MktIndexName:stat?.EntityName,
        field: `StatValue_${stat?.EntityName}`,
        valueFormatter: numberFormatter,
        cellStyle: colorCellStyle,
        headerTooltip: `${stat?.EntityName}`,
      })
    ),
  ];

  const correlationRowData = (firstCorrelationSummaryLine?.Entities || []).map(
    (entity) => {
      const row = { PeriodDesc: entity.PeriodDesc };
      (entity.Stats || []).forEach((stat) => {
        row[`StatValue_${stat?.EntityName}`] = stat?.StatValue;
      });
      return row;
    }
  );

  // Beta
  const BMStatSummaryBetaData = Gstate.ReturnsGridData?.BMStatSummaryBetaData;
  const Betadata=dt?.filter(item => item.StatDesc==="Beta");
  const Betadt = Betadata.map((stat) => ({
    ...stat,
    Entities: stat.Entities.map((item) => ({
      ...item,
      PeriodDesc: RadioValue === 5
        ? item.PeriodDesc === "Since Inception"
          ? "Selected Date"
          : item.PeriodDesc
        : item.PeriodDesc,
    })),
  }));
  const [firstBetaSummaryLine] = Betadt;

  const betaDatacolumnDefs = [
    {
      headerName: "Periods",
      field: "PeriodDesc",
      pinned: "left",
    },
    ...(firstBetaSummaryLine?.Entities?.[0]?.Stats || []).map((stat) => ({
      headerName: stat?.EntityName===null?MktIndexName:stat?.EntityName,
      field: `StatValue_${stat?.EntityName}`,
      valueFormatter: numberFormatter,
      cellStyle: colorCellStyle,
      headerTooltip: `${stat?.EntityName}`,
    })),
  ];

  const betaRowData = (firstBetaSummaryLine?.Entities || []).map((entity) => {
    const row = { PeriodDesc: entity.PeriodDesc };
    (entity.Stats || []).forEach((stat) => {
      row[`StatValue_${stat?.EntityName}`] = stat?.StatValue;
    });
    return row;
  });

  // Alpha
  const BMStatSummaryAlphaData = Gstate.ReturnsGridData?.BMStatSummaryAlphaData;
  const Alphadata=dt?.filter(item => item.StatDesc==="Alpha");
  const Alphadt =Alphadata.map((stat) => ({
    ...stat,
    Entities: stat.Entities.map((item) => ({
      ...item,
      PeriodDesc: RadioValue === 5
        ? item.PeriodDesc === "Since Inception"
          ? "Selected Date"
          : item.PeriodDesc
        : item.PeriodDesc,
    })),
  }));
  const [firstAlphaSummaryLine] = Alphadt;

  const alphaDatacolumnDefs = [
    {
      headerName: "Periods",
      field: "PeriodDesc",
      pinned: "left",
    },
    ...(firstAlphaSummaryLine?.Entities?.[0]?.Stats || []).map((stat) => ({
      headerName: stat?.EntityName===null?MktIndexName:stat?.EntityName,
      field: `StatValue_${stat?.EntityName}`,
      valueFormatter: numberFormatter,
      cellStyle: colorCellStyle,
      headerTooltip: stat?.EntityName,
    })),
  ];

  const alphaRowData = (firstAlphaSummaryLine?.Entities || []).map((entity) => {
    const row = { PeriodDesc: entity.PeriodDesc };
    (entity.Stats || []).forEach((stat) => {
      row[`StatValue_${stat?.EntityName}`] = stat?.StatValue;
    });
    return row;
  });

  // UpCapture
  const BMStatSummaryUpCaptureData =
    Gstate.ReturnsGridData?.BMStatSummaryUpCaptureData;
    const upcapturedata=dt?.filter(item => item.StatDesc==="Up Capture Ratio");
  const upcapturedt =upcapturedata.map((stat) => ({
    ...stat,
    Entities: stat.Entities.map((item) => ({
      ...item,
      PeriodDesc: RadioValue === 5
        ? item.PeriodDesc === "Since Inception"
          ? "Selected Date"
          : item.PeriodDesc
        : item.PeriodDesc,
    })),
  }));
  const [firstUpCaptureSummaryLine] =upcapturedt;
  

  const upCaptureDatacolumnDefs = [
    {
      headerName: "Periods",
      field: "PeriodDesc",
      pinned: "left",
    },
    ...(firstUpCaptureSummaryLine?.Entities?.[0]?.Stats || []).map((stat) => ({
      headerName: stat?.EntityName===null?MktIndexName:stat?.EntityName,
      field: `StatValue_${stat?.EntityName}`,
      valueFormatter: numberFormatter,
      cellStyle: colorCellStyle,
      headerTooltip: `${stat?.EntityName}`,
    })),
  ];

  const upCaptureRowData = (firstUpCaptureSummaryLine?.Entities || []).map(
    (entity) => {
      const row = { PeriodDesc: entity.PeriodDesc };
      (entity.Stats || []).forEach((stat) => {
        row[`StatValue_${stat?.EntityName}`] = stat?.StatValue;
      });
      return row;
    }
  );

  // DownCapture
  const BMStatSummaryDownCaptureData =
    Gstate.ReturnsGridData?.BMStatSummaryDownCaptureData;
    const Downcapturedata= dt?.filter(item => item.StatDesc==="Down Capture Ratio");
    const Downcapturedt =Downcapturedata.map((stat) => ({
      ...stat,
      Entities: stat.Entities.map((item) => ({
        ...item,
        PeriodDesc: RadioValue === 5
          ? item.PeriodDesc === "Since Inception"
            ? "Selected Date"
            : item.PeriodDesc
          : item.PeriodDesc,
      })),
    }));
  const [firstDownCaptureSummaryLine] =Downcapturedt;
 

  const downCaptureDatacolumnDefs = [
    {
      headerName: "Periods",
      field: "PeriodDesc",
      pinned: "left",
    },
    ...(firstDownCaptureSummaryLine?.Entities?.[0]?.Stats || []).map(
      (stat) => ({
        headerName: stat?.EntityName===null?MktIndexName:stat?.EntityName,
        field: `StatValue_${stat?.EntityName}`,
        valueFormatter: numberFormatter,
        cellStyle: colorCellStyle,
        headerTooltip: `${stat?.EntityName}`,
      })
    ),
  ];

  const downCaptureRowData = (firstDownCaptureSummaryLine?.Entities || []).map(
    (entity) => {
      const row = { PeriodDesc: entity.PeriodDesc };
      (entity.Stats || []).forEach((stat) => {
        row[`StatValue_${stat?.EntityName}`] = stat?.StatValue;
      });
      return row;
    }
  );

  // UpDownCapture
  const BMStatSummaryUpDownCaptureData =
    Gstate.ReturnsGridData?.BMStatSummaryUpDownCaptureData;
    const upDowncapturedata=  dt?.filter(item => item.StatDesc==="Up/Down Capture Ratio");
    const upDowncapturedt =upDowncapturedata.map((stat) => ({
      ...stat,
      Entities: stat.Entities.map((item) => ({
        ...item,
        PeriodDesc: RadioValue === 5
          ? item.PeriodDesc === "Since Inception"
            ? "Selected Date"
            : item.PeriodDesc
          : item.PeriodDesc,
      })),
    }));
  const [firstUpDownCaptureSummaryLine] =upDowncapturedt;
 
  const defaultColDef = {
    sortable: false,
    filter: false,
    suppressMovable: true,
    flex: 1,
    resizable:true
  };
  const upDownCaptureDatacolumnDefs = [
    {
      headerName: "Periods",
      field: "PeriodDesc",
      pinned: "left",
      flex: 0.7,
    },
    ...(firstUpDownCaptureSummaryLine?.Entities?.[0]?.Stats || []).map(
      (stat) => ({
        headerName:stat?.EntityName===null?MktIndexName:stat?.EntityName,
        field: `StatValue_${stat?.EntityName}`,
        valueFormatter: numberFormatter,
        cellStyle: colorCellStyle,
        headerTooltip: `${stat?.EntityName}`,
      })
    ),
  ];

  const upDownCaptureRowData = (
    firstUpDownCaptureSummaryLine?.Entities || []
  ).map((entity) => {
    const row = { PeriodDesc: entity.PeriodDesc };
    (entity.Stats || []).forEach((stat) => {
      row[`StatValue_${stat?.EntityName}`] = stat?.StatValue;
    });
    return row;
  });

  //BM DDHistory Grid

  const bMDDHistorycolumnDefs = [
    {
      field: "Magnitude",
      headerName: "Magnitude",
      width: 130,
      valueFormatter: percentFormatter,
      cellStyle: (params) => ({
        ...colorCellStyle(params),
        textAlign: "right",
      }),
      headerTooltip: "Magnitude",
    },
    {
      field: "Length",
      headerName: "Length (months)",
      width: 130,
      cellStyle: {
        textAlign: "right",
      },
      headerTooltip: "Length (months)",
    },
    {
      field: "StartDate",
      headerName: "Start Date",
      width: 130,
      valueFormatter: dateFormatter,
      headerTooltip: "Start Date",
    },
    {
      field: "LowPoint",
      headerName: "Low Point",
      width: 130,
      valueFormatter: dateFormatter,
      headerTooltip: "Low Point",
    },
    {
      field: "EndDate",
      headerName: "End Date",
      width: 130,
      valueFormatter: dateFormatter,
      headerTooltip: "End Date",
    },
    ...(BMDDHistoryData[0]?.BenchmarkRoRs || []).map((item) => ({
      headerName: item.EntityName,
      field: `BenchmarkRoRs_${item.EntityName}`,
      valueFormatter: percentFormatter,
      cellStyle: (params) => ({
        ...colorCellStyle(params),
        textAlign: "right",
      }),
      headerTooltip: `${item.EntityName}`,
    })),
  ];

  const bMDDHistoryrowData = Array.isArray(BMDDHistoryData)
    ? BMDDHistoryData.map((row) => {
      const rowDataItem = {
        Magnitude: row.Magnitude,
        Length: row.Length,
        StartDate: row.StartDate,
        LowPoint: row.LowPoint,
        EndDate: row.EndDate,
      };

      row.BenchmarkRoRs.forEach((item) => {
        rowDataItem[`BenchmarkRoRs_${item.EntityName}`] = item.CRoR;
      });

      return rowDataItem;
    })
    : [];

  // Custom value formatter for percentage format
  function percentFormatter(params) {
    const value = parseFloat(params.value);
    if (isNaN(value) || typeof value !== "number") {
      return "N/A";
    }
    const multipliedValue = value * 100;
    return `${multipliedValue.toFixed(1)}%`;
  }

  // Custom value formatter for number format
  function numberFormatter(params) {
    const value = parseFloat(params.value);
    if (isNaN(value) || typeof value !== "number") {
      return "N/A";
    }
    return `${value.toFixed(1)}`;
  }

  // Custom cell style to apply color if value < 0
  function colorCellStyle(params) {
    const value = parseFloat(params.value);
    return value < 0 ? { color: "red" } : null;
  }

  function dateFormatter(params) {
    if (!params.value) {
      return "N/A";
    }
    const date = moment(params.value);
    return date.format("MMM-YYYY");
  }

  //onchange
  const toggleButton = (buttonName) => {
    switch (buttonName) {
      case "rorGrid":
        setRorGridbuttonActive(true);
        setRorChartbuttonActive(false);
        break;
      case "rorChart":
        setRorGridbuttonActive(false);
        setRorChartbuttonActive(true);
        break;
      case "stdDevGrid":
        setStdDevGridbuttonActive(true);
        setStdDevChartbuttonActive(false);
        break;
      case "stdDevChart":
        setStdDevGridbuttonActive(false);
        setStdDevChartbuttonActive(true);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    loadSummaryWidgets();
  }, [rorChartbuttonActive, stdDevChartbuttonActive]);
  // useEffect(() => {
  //   loadSummaryWidgets();
  // }, []);

  const SaveWidgetSettings = async () => {
    const saveData = {
      "componentId": 1005,
      "componentUserSettingId": 0,
      "userId": 0,
      "customSettingsValue": JSON.stringify(WidgetCollections),
      "isGrid": false
    };

    sbaAxios({ url: updateCustomSettings, method: 'post', data: saveData })
      .then(async (response) => {
        setIsSave(false);
        setupdateshow(true);
        setcancelshow(false);
        setShowIcon(false);
      })
      .catch((error) => {
        console.log(error);
      });



  }

  const loadSummaryWidgets = () => {

    const TotalRemovedCount = $.grep(WidgetCollections, function (item) {
      return item.IsRemoved === true;
    });

    const Maintiles = [];
    WidgetCollections.map(function (item) {
      if (item.IsRemoved === false && item.WidgetName === "RORwidget") {
        const tile = {
          header: (
            <div className="d-flex justify-content-between">
              <p> ROR </p>
              <div className="d-inline-flex">
                <button
                  className={`toggle-btn rounded-start ${rorGridbuttonActive ? "activeBtn" : "nonactiveBtn"
                    }`}
                  onClick={() => toggleButton("rorGrid")}
                >
                  <i className="fa-solid fa-bars"></i>
                </button>
                <button
                  className={`toggle-btn rounded-end ${rorChartbuttonActive ? "activeBtn" : "nonactiveBtn"
                    }`}
                  onClick={() => toggleButton("rorChart")}
                >
                  <i className="fa-solid fa-chart-line"></i>
                </button>
                {showIcon && (
                  <a
                    className="ms-auto"
                    href="#"
                    onClick={() => RemoveWidget(item.WidgetName)}
                  >
                    <img src={close} alt="close" />
                  </a>
                )}
              </div>
            </div>
          ),

          body:
            rorRowData.length > 0 ? (
              <div className="ag-container-height">
                <div className="ag-theme-alpine">
                  {rorGridbuttonActive && (
                    <AgGridReact
                      columnDefs={rorDatacolumnDefs}
                      rowData={rorRowData}
                      defaultColDef={defaultColDef}
                      domLayout="autoHeight"
                      enableBrowserTooltips={true}
                    />
                  )}
                  {rorChartbuttonActive && rorChart}
                </div>
              </div>
            ) : (
              <p style={{ color: "red", textAlign: "center" }}>No data available</p>
            ),
          reorderable: cancelShow,
        };

        Maintiles.push(tile);
      }
      if (item.IsRemoved === false && item.WidgetName === "StandardDeviationwidget") {
        const tile = {
          header: (
            <div className="d-flex justify-content-between">
              <p> Standard Deviation </p>
              <div className="d-inline-flex">
                <button
                  className={`toggle-btn rounded-start ${stdDevGridbuttonActive ? "activeBtn" : "nonactiveBtn"
                    }`}
                  onClick={() => toggleButton("stdDevGrid")}
                >
                  <i className="fa-solid fa-bars"></i>
                </button>
                <button
                  className={`toggle-btn rounded-end ${stdDevChartbuttonActive ? "activeBtn" : "nonactiveBtn"
                    }`}
                  onClick={() => toggleButton("stdDevChart")}
                >
                  <i className="fa-solid fa-chart-line"></i>
                </button>
                {showIcon && (
                  <a
                    className="ms-auto"
                    href="#"
                    onClick={() => RemoveWidget(item.WidgetName)}
                  >
                    <img src={close} alt="close" />
                  </a>
                )}
              </div>
            </div>
          ),

          body:
            stdDevRowData.length > 0 ? (
              <div className="ag-theme-alpine">
                {stdDevGridbuttonActive && (
                  <AgGridReact
                    columnDefs={stdDevDatacolumnDefs}
                    rowData={stdDevRowData}
                    defaultColDef={defaultColDef}
                    domLayout="autoHeight"
                    enableBrowserTooltips={true}
                  />
                )}
                {stdDevChartbuttonActive && stdDevChart}
              </div>
            ) : (
              <p style={{ color: "red", textAlign: "center" }}>No data available</p>
            ),
          reorderable: cancelShow,
        };

        Maintiles.push(tile);
      }
      if (item.IsRemoved === false && item.WidgetName === "Sharpewidget") {
        const tile = {
          header: (
            <div className="d-flex justify-content-between">
              <p> Sharpe </p>
              <div className="d-inline-flex">
                {/* <button className="toggle-btn rounded-start active"><i className="fa-solid fa-bars"></i></button>
          <button className="toggle-btn rounded-end" disabled=""><i className="fa-solid fa-chart-line"></i></button> */}
                {showIcon && (
                  <a
                    className="ms-auto"
                    href="#"
                    onClick={() => RemoveWidget(item.WidgetName)}
                  >
                    <img src={close} alt="close" />
                  </a>
                )}
              </div>
            </div>
          ),
          body:
            sharpeRowData.length > 0 ? (
              <div className="ag-theme-alpine">
                <AgGridReact
                  columnDefs={sharpeDatacolumnDefs}
                  rowData={sharpeRowData}
                  defaultColDef={defaultColDef}
                  enableBrowserTooltips={true}
                />
              </div>
            ) : (
              <p style={{ color: "red", textAlign: "center" }}>No data available</p>
            ),
          reorderable: cancelShow,
        };
        Maintiles.push(tile);
      }
      if (item.IsRemoved === false && item.WidgetName === "Sortinowidget") {
        const tile = {
          header: (
            <div className="d-flex justify-content-between">
              <p> Sortino </p>
              <div className="d-inline-flex">
                {/* <button className="toggle-btn rounded-start active"><i className="fa-solid fa-bars"></i></button>
            <button className="toggle-btn rounded-end" disabled=""><i className="fa-solid fa-chart-line"></i></button> */}
                {showIcon && (
                  <a
                    className="ms-auto"
                    href="#"
                    onClick={() => RemoveWidget(item.WidgetName)}
                  >
                    <img src={close} alt="close" />
                  </a>
                )}
              </div>
            </div>
          ),
          body:
            sortinoRowData.length > 0 ? (
              <div className="ag-theme-alpine">
                <AgGridReact
                  columnDefs={sortinoDatacolumnDefs}
                  rowData={sortinoRowData}
                  defaultColDef={defaultColDef}
                  enableBrowserTooltips={true}
                />
              </div>
            ) : (
              <p style={{ color: "red", textAlign: "center" }}>No data available</p>
            ),
          reorderable: cancelShow,
        };
        Maintiles.push(tile);
      }
      if (item.IsRemoved === false && item.WidgetName === "MaxDrawDownwidget") {
        const tile = {
          header: (
            <div className="d-flex justify-content-between">
              <p> Max Drawdown </p>
              <div className="d-inline-flex">
                {/* <button className="toggle-btn rounded-start active"><i className="fa-solid fa-bars"></i></button>
    <button className="toggle-btn rounded-end" disabled=""><i className="fa-solid fa-chart-line"></i></button> */}
                {showIcon && (
                  <a
                    className="ms-auto"
                    href="#"
                    onClick={() => RemoveWidget(item.WidgetName)}
                  >
                    <img src={close} alt="close" />
                  </a>
                )}
              </div>
            </div>
          ),
          body:
            maxDrawdownRowData.length > 0 ? (
              <div className="ag-theme-alpine">
                <AgGridReact
                  columnDefs={maxDrawdownDatacolumnDefs}
                  rowData={maxDrawdownRowData}
                  defaultColDef={defaultColDef}
                  enableBrowserTooltips={true}
                />
              </div>
            ) : (
              <p style={{ color: "red", textAlign: "center" }}>No data available</p>
            ),
          reorderable: cancelShow,
        };
        Maintiles.push(tile);
      }
      if (item.IsRemoved === false && item.WidgetName === "Correlationwidget") {
        const tile = {
          header: (
            <div className="d-flex justify-content-between">
              <p> Correlation </p>
              <div className="d-inline-flex">
                {/* <button className="toggle-btn rounded-start active"><i className="fa-solid fa-bars"></i></button>
                <button className="toggle-btn rounded-end" disabled=""><i className="fa-solid fa-chart-line"></i></button> */}
                {showIcon && (
                  <a
                    className="ms-auto"
                    href="#"
                    onClick={() => RemoveWidget(item.WidgetName)}
                  >
                    <img src={close} alt="close" />
                  </a>
                )}
              </div>
            </div>
          ),
          body:
            correlationRowData.length > 0 ? (
              <div className="ag-theme-alpine">
                <AgGridReact
                  columnDefs={correlationDatacolumnDefs}
                  rowData={correlationRowData}
                  defaultColDef={defaultColDef}
                  enableBrowserTooltips={true}
                />
              </div>
            ) : (
              <p style={{ color: "red", textAlign: "center" }}>No data available</p>
            ),
          reorderable: cancelShow,
        };
        Maintiles.push(tile);
      }
      if (item.IsRemoved === false && item.WidgetName === "Betawidget") {
        const tile = {
          header: (
            <div className="d-flex justify-content-between">
              <p> Beta </p>
              <div className="d-inline-flex">
                {/* <button className="toggle-btn rounded-start active"><i className="fa-solid fa-bars"></i></button>
                  <button className="toggle-btn rounded-end" disabled=""><i className="fa-solid fa-chart-line"></i></button> */}
                {showIcon && (
                  <a
                    className="ms-auto"
                    href="#"
                    onClick={() => RemoveWidget(item.WidgetName)}
                  >
                    <img src={close} alt="close" />
                  </a>
                )}
              </div>
            </div>
          ),
          body:
            betaRowData.length > 0 ? (
              <div className="ag-theme-alpine">
                <AgGridReact
                  columnDefs={betaDatacolumnDefs}
                  rowData={betaRowData}
                  defaultColDef={defaultColDef}
                  enableBrowserTooltips={true}
                />
              </div>
            ) : (
              <p style={{ color: "red", textAlign: "center" }}>No data available</p>
            ),
          reorderable: cancelShow,
        };
        Maintiles.push(tile);
      }
      if (item.IsRemoved === false && item.WidgetName === "Alphawidget") {
        const tile = {
          header: (
            <div className="d-flex justify-content-between">
              <p> Alpha </p>
              <div className="d-inline-flex">
                {/* <button className="toggle-btn rounded-start active"><i className="fa-solid fa-bars"></i></button>
                <button className="toggle-btn rounded-end" disabled=""><i className="fa-solid fa-chart-line"></i></button> */}
                {showIcon && (
                  <a
                    className="ms-auto"
                    href="#"
                    onClick={() => RemoveWidget(item.WidgetName)}
                  >
                    <img src={close} alt="close" />
                  </a>
                )}
              </div>
            </div>
          ),
          body:
            alphaRowData.length > 0 ? (
              <div className="ag-theme-alpine">
                <AgGridReact
                  columnDefs={alphaDatacolumnDefs}
                  rowData={alphaRowData}
                  defaultColDef={defaultColDef}
                  enableBrowserTooltips={true}
                />
              </div>
            ) : (
              <p style={{ color: "red", textAlign: "center" }}>No data available</p>
            ),
          reorderable: cancelShow,
        };
        Maintiles.push(tile);
      }
      if (item.IsRemoved === false && item.WidgetName === "UpCaptureRatiowidget") {
        const tile = {
          header: (
            <div className="d-flex justify-content-between">
              <p> Up Capture Ratio </p>
              <div className="d-inline-flex">
                {/* <button className="toggle-btn rounded-start active"><i className="fa-solid fa-bars"></i></button>
                <button className="toggle-btn rounded-end" disabled=""><i className="fa-solid fa-chart-line"></i></button> */}
                {showIcon && (
                  <a
                    className="ms-auto"
                    href="#"
                    onClick={() => RemoveWidget(item.WidgetName)}
                  >
                    <img src={close} alt="close" />
                  </a>
                )}
              </div>
            </div>
          ),
          body:
            upCaptureRowData.length > 0 ? (
              <div className="ag-theme-alpine">
                <AgGridReact
                  columnDefs={upCaptureDatacolumnDefs}
                  rowData={upCaptureRowData}
                  defaultColDef={defaultColDef}
                  enableBrowserTooltips={true}
                />
              </div>
            ) : (
              <p style={{ color: "red", textAlign: "center" }}>No data available</p>
            ),
          reorderable: cancelShow,
        };
        Maintiles.push(tile);
      }
      if (item.IsRemoved === false && item.WidgetName === "DownCapturewidget") {
        const tile = {
          header: (
            <div className="d-flex justify-content-between">
              <p> Down Capture Ratio </p>
              <div className="d-inline-flex">
                {/* <button className="toggle-btn rounded-start active"><i className="fa-solid fa-bars"></i></button>
              <button className="toggle-btn rounded-end" ><i className="fa-solid fa-chart-line"></i></button> */}
                {showIcon && (
                  <a
                    className="ms-auto"
                    href="#"
                    onClick={() => RemoveWidget(item.WidgetName)}
                  >
                    <img src={close} alt="close" />
                  </a>
                )}
              </div>
            </div>
          ),
          body:
            downCaptureRowData.length > 0 ? (
              <div className="ag-theme-alpine">
                <AgGridReact
                  columnDefs={downCaptureDatacolumnDefs}
                  rowData={downCaptureRowData}
                  defaultColDef={defaultColDef}
                  enableBrowserTooltips={true}
                />
              </div>
            ) : (
              <p style={{ color: "red", textAlign: "center" }}>No data available</p>
            ),
          reorderable: cancelShow,
        };
        Maintiles.push(tile);
      }
      if (item.IsRemoved === false && item.WidgetName === "UpDownCapturewidget") {
        const tile = {
          header: (
            <div className="d-flex justify-content-between">
              <p> UpDown Capture Ratio </p>
              <div className="d-inline-flex">
                {/* <button className="toggle-btn rounded-start active"><i className="fa-solid fa-bars"></i></button>
              <button className="toggle-btn rounded-end" ><i className="fa-solid fa-chart-line"></i></button> */}
                {showIcon && (
                  <a
                    className="ms-auto"
                    href="#"
                    onClick={() => RemoveWidget(item.WidgetName)}
                  >
                    <img src={close} alt="close" />
                  </a>
                )}
              </div>
            </div>
          ),
          body:
            upDownCaptureRowData.length > 0 ? (
              <div className="ag-theme-alpine">
                <AgGridReact
                  columnDefs={upDownCaptureDatacolumnDefs}
                  rowData={upDownCaptureRowData}
                  defaultColDef={defaultColDef}
                  enableBrowserTooltips={true}
                />
              </div>
            ) : (
              <p style={{ color: "red", textAlign: "center" }}>No data available</p>
            ),
          reorderable: cancelShow,
        };
        Maintiles.push(tile);
      }
      //Empty widget
      // if ( item.IsRemoved === false && item.WidgetName === "UpDownCapturewidget")
      // {
      //   const tile = {         
      //     body:
      //     (<></>),
      //     reorderable: false,
      //   };
      //   Maintiles.push(tile);
      // }

    });
    if (showIcon == true) {
      if (TotalRemovedCount.length > 0) {
        const tile = {
          body: (
            <div className="ag-container-height">
              <button
                className="d-inline-block w-100 h-100 fs-5"
                data-bs-toggle="modal"
                data-bs-target="#SummaryWidgetModal"
              >
                + Add a Widget
              </button>
            </div>
          ),
        };
        Maintiles.push(tile);
      }
    }
    setTiles(Maintiles);
    setIsChartLoading(false);
  };
  const handleReposition = (e) => {
    setData(e.value);
    WidgetCollections.forEach((widget, index) => {
      if (e.value[index]) {
        widget.SortOrder = e.value[index].order;
      }
    });
    WidgetCollections.forEach((widget, index) => {
      widget.dataPosition = e.value[index];
    });

    setWidgetCollections(WidgetCollections);
    loadSummaryWidgets();
  };
  const RemoveWidget = (name) => {
    $.grep(WidgetCollections, function (item) {
      if (item.WidgetName === name) {
        item.IsRemoved = true;
      }
    });
    setWidgetCollections(WidgetCollections);
    loadSummaryWidgets();
  };
  const AddSummaryWidget = () => {
    return (
      <div className="row">
        {SummaryWidgetCollections.map(function (item) {
          if (item.IsRemoved === true) {
            return (
              <div className="col-sm-4 col-md-4">
                <div className="widget-checkbox rounded">
                  <div className="form-check float-end">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id={"tilesCheck_" + item.WidgetName}
                      onChange={() => setsummarywidgets(item.WidgetName)}
                    />
                  </div>
                </div>
                <span className="mt-2 d-inline-block">{item.TileName}</span>
              </div>
            );
          }
          return null;
        })}
      </div>
    );
  };

  const setsummarywidgets = (name) => {
    $.grep(WidgetCollections, function (item) {
      if (item.WidgetName == name) {
        if ($("#tilesCheck_" + item.WidgetName + "").prop("checked") == true)
          item.IsRemoved = false;
      }
    });

    setWidgetCollections(WidgetCollections);
  };

  return (
    <>
      {isChartLoading ? (
        // Render the LoadingScreen component when isLoading is true
        <LoadingScreen />
      ) : (
        <>
          <div id="content" className="dashboard analytics-summary px-2 mb-4">
            <TileLayout
              columns={4}
              rowHeight={"auto"}
              positions={data}
              gap={{
                rows: 10,
                columns: 10,
              }}
              items={tiles}
              onReposition={handleReposition}
            />

          </div>
          <div classname="row">
            <div className="col-lg-12 d-flex gap-2 p-2">
              <div className="col-md-6">
                <label>DrawdownHistory</label>
                {bMDDHistoryrowData.length > 0 ? (
                  <div className="ag-theme-alpine" style={{ width: '100%', height: '700px' }}>
                    <AgGridReact
                      columnDefs={bMDDHistorycolumnDefs}
                      rowData={bMDDHistoryrowData}
                      defaultColDef={defaultColDef}
                      enableBrowserTooltips={true}
                      onGridReady={(params) => {
                        CalendarExcel.current = params.api;
                      }}
                    />
                  </div>
                ) : (
                  <p style={{ color: "red", textAlign: "center" }}>No data available</p>
                )
                }
              </div>
              <div className="col-md-6">
                <label>CalendarYears</label>
                {rowData.length > 0 ? (
                  <div className="ag-theme-alpine" style={{ width: '100%', height: '700px' }}>
                    <AgGridReact
                      columnDefs={columnDefs}
                      rowData={rowData}
                      defaultColDef={defaultColDef}
                      enableBrowserTooltips={true}
                      onGridReady={(params) => {
                        CalendarExcel.current = params.api;
                      }}
                    />
                  </div>
                ) : (
                  <p style={{ color: "red", textAlign: "center" }}>No data available</p>
                )
                }
              </div>
            </div>
          </div>
          <div className="row">

            <div
              className="modal fade"
              id="SummaryWidgetModal"
              tabIndex="-1"
              aria-labelledby="SummaryWidgetModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable widget-add-modal">
                <div className="modal-content p-2 overflow-auto">
                  <div className="modal-header">
                    <h1 className="modal-title fs-5" id="SummaryWidgetModalLabel">
                      Add Widgets
                    </h1>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <form action="#">
                    <div className="modal-body ">
                      <h6 className="fw-medium fs-6 mt-3">
                        Click on the widget checkbox to add
                      </h6>
                      <AddSummaryWidget />
                    </div>
                    <div className="modal-footer border-0">
                      <button
                        type="button"
                        className="cancel-btn"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="apply-btn"
                        onClick={() => loadSummaryWidgets()}
                        data-bs-dismiss="modal"
                      >
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      )} 
    </>
  );
};

export default SummaryTab;
